import { render, staticRenderFns } from "./compareCostAndProfits.vue?vue&type=template&id=3b8168d7&scoped=true&"
import script from "./compareCostAndProfits.vue?vue&type=script&lang=js&"
export * from "./compareCostAndProfits.vue?vue&type=script&lang=js&"
import style0 from "./compareCostAndProfits.vue?vue&type=style&index=0&id=3b8168d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8168d7",
  null
  
)

export default component.exports